import React from 'react'

export const IconRightArrow = (props) => {
    return (
        <svg width="13" height="16" viewBox="0 0 13 16" fill="none" {...props}>
            <path d="M3 8H10M10 8L7.52941 5M10 8L7.52941 11" stroke="currentColor" strokeWidth="1.6" strokeLinecap="square" />
        </svg>
    )
}